import { MessageType_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { Direction, Encoding, Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';

/**
 * All the values in an SMS that will be unpopulated or inaccurate when using `ListThreads` or `GetThreadDetails` in
 * sms-data-v4
 */
export const SMS_V4_UNPOPULATED_VALUES = {
  actionable: false,
  createdBy: '',
  deadline: '',
  deletedAt: '',
  deletedBy: '',
  departmentId: '',
  direction: Direction.DIRECTION_UNSPECIFIED,
  encoding: Encoding.ENCODING_UNSPECIFIED,
  labels: {},
  media: [],
  messageType: MessageType_Enum.UNSPECIFIED,
  personId: '',
  programSlugId: '',
  providerMsgId: '',
  readAt: '',
  readBy: '',
  relatedIds: [],
  segments: 0,
  status: Status.STATUS_UNSPECIFIED,
  statusDetails: '',
  tags: [],
  tagsDetailed: [],
  updatedAt: '',
  updatedBy: '',
} as const satisfies Partial<SMS>;
